// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { UtilGetString, FormattedDurationGetString } from './types.generated'

const utilLocales = ['en-US'] as const

export const getString: UtilGetString = i18nBundle('util', utilLocales).getString
export const getStringUtil: UtilGetString = getString

const formattedDurationLocales = ['en-US'] as const

export const getStringFormattedDuration: FormattedDurationGetString = i18nBundle('formattedDuration', formattedDurationLocales).getString

